/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    './src/pages/**/*.{js,ts,jsx,tsx,mdx}',
    './src/components-new/**/*.{js,ts,jsx,tsx,mdx}',
    './src/**/*.{js,ts,jsx,tsx}',
  ],
  theme: {
    listStyleType: {
      none: 'none',
      disc: 'disc',
      decimal: 'decimal',
      square: 'square',
      roman: 'upper-roman',
      'lower-roman': 'lower-roman',
      alpha: 'lower-alpha',
    },
    screens: {
      sm: '640px',
      md: '768px',
      lg: '1024px',
      '2l': '1100px',
      xl: '1280px',
      '1xl': '1440px',
      '2xl': '1600px',
      '3xl': '1920px',
      '4xl': '2020px',
    },
    fontFamily: {
      LibreBaskervilleRegular: 'LibreBaskervilleRegular, GESSTwoDWTCLight, sans-serif',
      DINRegular: 'DINRegular, sans-serif',
      DINMedium: 'DINMedium, sans-serif',
      DINBold: 'DINBold, sans-serif',
      URWDINRegular: 'URWDINRegular, GESSTwoDWTCLight, sans-serif',
      URWDINMedium: 'URWDINMedium, GESSTwoDWTCMedium, sans-serif',
      URWDINBold: 'URWDINBold, GESSTwoDWTCMedium, sans-serif',
      GESSTwoDWTCMedium: 'GESSTwoDWTCMedium, URWDINMedium, sans-serif',
      GESSTwoDWTCLight: 'GESSTwoDWTCLight, URWDINRegular, sans-serif',
    },
    lineHeight: {
      1: '1',
      1.125: '1.125',
      1.2: '1.2',
      1.25: '1.25',
      1.3: '1.3',
      1.375: '1.375',
      1.4: '1.4',
      1.5: '1.5',
      1.6: '1.6',
      1.625: '1.625',
      1.75: '1.75',
      1.875: '1.875',
      2: '2',
    },
    extend: {
      fontSize: {
        xxs: '10px',
        clamp10to14: 'clamp(0.625rem, 0.575rem + 0.25vw, 0.875rem)',
        clamp10to16: 'clamp(0.625rem, 0.55rem + 0.375vw, 1rem)',
        clamp10to18: 'clamp(0.625rem, 0.525rem + 0.5vw, 1.125rem)',
        clamp10to20: 'clamp(0.625rem, 0.5rem + 0.625vw, 1.25rem)',
        clamp11to15: 'clamp(0.6875rem, 0.6375rem + 0.25vw, 0.9375rem)',
        clamp11to16: 'clamp(0.6875rem, 0.625rem + 0.3125vw, 1rem)',
        clamp11to18: 'clamp(0.6875rem, 0.6rem + 0.4375vw, 1.125rem)',
        clamp12to14: 'clamp(0.75rem, 0.725rem + 0.125vw, 0.875rem)',
        clamp12to15: 'clamp(0.75rem, 0.7125rem + 0.1875vw, 0.9375rem)',
        clamp12to16: 'clamp(0.75rem, 0.7rem + 0.25vw, 1rem)',
        clamp12to18: 'clamp(0.75rem, 0.675rem + 0.375vw, 1.125rem)',
        clamp12to20: 'clamp(0.75rem, 0.65rem + 0.5vw, 1.25rem)',
        clamp12_8to16: 'clamp(0.8rem, 0.76rem + 0.2vw, 1rem)',
        clamp13to16: 'clamp(0.8125rem, 0.775rem + 0.1875vw, 1rem)',
        clamp13to18: 'clamp(0.8125rem, 0.75rem + 0.3125vw, 1.125rem)',
        clamp13to20: 'clamp(0.8125rem, 0.725rem + 0.4375vw, 1.25rem)',
        clamp13to25: 'clamp(0.8125rem, 0.6625rem + 0.75vw, 1.5625rem)',
        clamp14to16: 'clamp(0.875rem, 0.85rem + 0.125vw, 1rem)',
        clamp14to18: 'clamp(0.875rem, 0.825rem + 0.25vw, 1.125rem)',
        clamp14to20: 'clamp(0.875rem, 0.8rem + 0.375vw, 1.25rem)',
        clamp14to25: 'clamp(0.875rem, 0.7375rem + 0.6875vw, 1.5625rem)',
        clamp15to18: 'clamp(0.9375rem, 0.9rem + 0.1875vw, 1.125rem)',
        clamp16to18: 'clamp(1rem, 0.975rem + 0.125vw, 1.125rem)',
        clamp15to20: 'clamp(0.9375rem, 0.875rem + 0.3125vw, 1.25rem)',
        clamp15to19: 'clamp(0.9375rem, 0.8875rem + 0.25vw, 1.1875rem)',
        clamp15to30: 'clamp(0.9375rem, 0.75rem + 0.9375vw, 1.875rem)',
        clamp22to30: 'clamp(1.375rem, 1.275rem + 0.5vw, 1.875rem)',
        clamp16to20: 'clamp(1rem, 0.95rem + 0.25vw, 1.25rem)',
        clamp16to24: 'clamp(1rem, 0.9rem + 0.5vw, 1.5rem);',
        clamp16to25: 'clamp(1rem, 0.8875rem + 0.5625vw, 1.5625rem)',
        clamp16to30: 'clamp(1rem, 0.825rem + 0.875vw, 1.875rem)',
        clamp18to25: 'clamp(1.125rem, 1.0375rem + 0.4375vw, 1.5625rem)',
        clamp20to25: 'clamp(1.25rem, 1.1875rem + 0.3125vw, 1.5625rem)',
        clamp20to30: 'clamp(1.25rem, 1.125rem + 0.625vw, 1.875rem)',
        clamp20to40: 'clamp(1.25rem, 1rem + 1.25vw, 2.5rem)',
        clamp20to48: 'clamp(1.25rem, 0.9rem + 1.75vw, 3rem)',
        clamp20to60: 'clamp(1.25rem, 0.75rem + 2.5vw, 3.75rem)',
        clamp21to27: 'clamp(1.3125rem, 1.2375rem + 0.375vw, 1.6875rem)',
        clamp24to40: 'clamp(1.5rem, 1.3rem + 1vw, 2.5rem)',
      },
      aspectRatio: {
        '16/9': [16, 9],
        '4/3': [4, 3],
        '3/2': [3, 2],
        '1/1': [1, 1],
        '37/30': [37, 30],
        '49/58': [49, 58]
      },
      spacing: {
        '44vw': '44vw',
        '60vw': '60vw',
        1.25: '5px',
        7.5: '30px',
        4.5: '18px',
        11.75: '47px',
        12.5: '50px',
        13.5: '54px',
        15: '60px',
        18.75: '75px',
        22.5: '90px',
        24.5: '98px',
        25: '100px',
        29: '116px',
        30: '120px',
        37.5: '150px',
        39.5: '158px',
        42.5: '170px',
        44: '176px',
        45: '180px',
        47.5: '190px',
        53.5: '214px',
        55: '220px',
        58: '232px',
        68: '272px',
        70: '280px',
        75: '300px',
        80: '320px',
        115: '460px',
        120: '480px',
        142.5: '570px',
        146.25: '585px',
        155: '620px',
        160: '640px',
        199: '796px',
        133: '532px',
        168: '672px',
        203: '812px',
        211: '844px',
        238: '952px',
        292.5: '1170px',
      },
      height: {
        80: '320px',
        115: '460px',
        120: '480px',
        160: '640px',
        199: '796px',
        133: '532px',
        168: '672px',
        203: '812px',
        238: '952px',
        '60vw': '60vw',
      },
      colors: {
        watermelon: '#CE445B',
        red: '#CE445B',
        darkGray: '#333333',
        liver: '#4D4D4D',
        carbonGrey: '#58595B',
        desertStorm: '#F7F7F7',
        silver: '#cccccc',
        ghostWhite: '#FAFAFA',
        oil: '#231F20',
        porcelain: '#F2F2F2'
      },
      backgroundImage: {
        'texture': "url('/src/images/texture.jpeg')",
      },
      opacity: {
        '15': '.15',
      }
    },
  },
  plugins: [
    ({ addVariant }) => {
      addVariant('lazy-load-image', '& > .lazy-load-image-background');
      addVariant('h1-strong', '& > h1 > strong');
      addVariant('swiper-slide', '& > .swiper-wrapper > .swiper-slide');
      addVariant('swiper-slide-active', '& > .swiper-wrapper > .swiper-slide-active');
      addVariant('swiper-pagination', '& > .swiper-pagination');
      addVariant('dot-line', '& > .dot-line');
      addVariant('swiper-pagination-bullet', '& > .swiper-pagination > .swiper-pagination-bullet');
      addVariant('swiper-pagination-bullet-active', '& > .swiper-pagination > .swiper-pagination-bullet-active');
      addVariant('h2-strong', '& > h2 > strong');
      addVariant('h2-child', '& > h2');
      addVariant('h1-child', '& > h1');
      addVariant('h1-strong-br', '& > h1 > strong > br');
      addVariant('p-strong-br', '& > p > strong > br');
      addVariant('child', '& > *');
      addVariant('br-break', '& > * > br');
      addVariant('p-child', '& > p');
      addVariant('tax-class', '& > .tax-class');
      addVariant('p-a-child', '& > p > a');
      addVariant('h6-child', '& > h6');
      addVariant('p-strong', '& > p > strong');
      addVariant('svg-path', '& > svg > path');
      addVariant('dot-rounded', '& > .rounded-dots');
      addVariant('process-line','& > .process-way')
      addVariant('ul-child', '& > ul');
      addVariant('ul-a-child', '& > ul > li > a');
      addVariant('li-child', '& > ul > li');
    },
  ],
}
